import FlashcardQuestionConfig from './FlashcardQuestionConfig';
import FlashcardQuestionResponse from './FlashcardQuestionReponse';
class FlashcardPageMetaDataClass {
    constructor(config = {}) {
        config = config || {};
        this.templateId = config.templateId || '';
        this.backgroundUrl = config.backgroundUrl || '';
        this.backgroundOpacity = config.backgroundOpacity || 100; 
        this.consumableBackgroundUrl = config.consumableBackgroundUrl || '';
        this.isQuizTemplate = config.isQuizTemplate || false;
        this.questionId = config.questionId || 0;
        this.questionConfig = FlashcardQuestionConfig(config.questionConfig);
        this.questionResponse = FlashcardQuestionResponse(config.questionResponse);
        this.contentAlignment = config.contentAlignment || FlashcardPageMetaData.ALIGNMENT_TYPES.NONE;
    }

    getBackgroundUrl() {
        return this.consumableBackgroundUrl;
    }

    getBackgroundOpacity(){
        return this.backgroundOpacity;
    }

    getTemplateId() {
        return this.templateId;
    }
    
    isQuiz(){
        return this.isQuizTemplate;
    }
    getCorrectOption(){
        return this.questionConfig.getCorrectOption();
    }
    setQuestionReponse(response){
        if(!(response instanceof FlashcardQuestionResponse)){
            response = new FlashcardQuestionResponse(response)
        }
        this.questionResponse = response;
    }
    isMandatory(){
        return this.questionConfig.getIsMandatory();
    }

    isTimedQuiz(){
        return this.isQuiz()
            && this.isMandatory()
            && this.questionConfig.isTimed();
    }

    isCorrect(selectedOptions){
        return this.questionConfig.isCorrect(selectedOptions);
    }
    canReattemptQuiz(){
        return this.isQuiz()
            && this.questionResponse.isAnswered()
            && !this.questionResponse.isCorrect
            && (this.questionConfig.getReattemptCount() >= this.questionResponse.getTotalAttempts());
    }
}

const FlashcardPageMetaData = config => new FlashcardPageMetaDataClass(config)
FlashcardPageMetaData.ALIGNMENT_TYPES = {
    NONE: 0,
    CENTER: 1,
    FLEX_START: 2,
    FLEX_END: 3,
    SPACE_AROUND: 4,
    SPACE_BETWEEN: 5,
    SPACE_EVENLY: 6
};
export default FlashcardPageMetaData